module.exports = __webpack_public_path__ + "static/media/m19.0b8184bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/merletto/m19.jpg
// module id = 440
// module chunks = 0